// @flow

import * as React from 'react';
import * as Types from '@ta/trips.trip-types';
import TrackImpression from './TrackImpression';

type Props = {|
  element: string,
  trip?: Types.Trip,
  trips?: Types.Trip[],
  item?: { saved: boolean },
  children: React.Node,
|};

const getTripType = (
  trip?: Types.Trip,
  hasTrips?: boolean,
): 'COLLABORATED' | 'COLLABORATOR' | 'EXISTING' | 'FIRST' | 'NEW' => {
  // if they have no trips, the only thing this can be is their first trip
  if (!hasTrips) {
    return 'FIRST';
  }
  // they have trips, but not an existing one. This is a new trip
  if (!trip) {
    return 'NEW';
  }

  // if they are modify the trip but they are not the owner, then they are a collaborator
  if (trip && trip.owner && !trip.owner.isMe) {
    return 'COLLABORATOR';
  }

  // this is an existing trip and it is our trip. If it has collaborators the it is a 'collaborated' trip
  if (trip && trip.collaborators && trip.collaborators.length > 0) {
    return 'COLLABORATED';
  }

  // this trip is an existing trip with no collaborators being modified by the owner.
  return 'EXISTING';
};

const TripsImpression = ({ element, trip, trips, item, children }: Props) => {
  // we're assuming that these trips belong to the actor (like in the STAT modal).
  const hasTrips = trips ? trips.length > 0 : undefined;
  // get the trip type if we A) have a trip and B) have the other trips to compare it to
  const tripType = trip && hasTrips !== undefined ? getTripType(trip, hasTrips) : undefined;

  return (
    <TrackImpression
      source="trips"
      attributes={{
        trips: {
          element,
          tripId: trip && trip.id,
          tripType,
          hasTrips,
          dated:
            trip && !!trip.date && (!!trip.date.to || !!trip.date.from || !!trip.date.duration),
          isSaved: item && item.saved,
        },
      }}
    >
      {children}
    </TrackImpression>
  );
};

export default TripsImpression;
